/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useSnapshot } from 'valtio';

import Filter from './filter';

import { refsStore, eventsStore } from '../managers/globalState';
import { EVENT_CATEGORIES } from '../config/constants';
import { updateYear, updateCategory } from '../helpers/processEvents';

import '../../www/assets/css/event_dropdowns.css';

const EventDropdowns = () => {
	// Get the year and category index global state.
	const { yearIndex, categoryIndex, showOnGlobe } = useSnapshot(eventsStore.state);

	// Get the content manager using the global state 'get' reference.
	const { get } = useSnapshot(refsStore.state);
	const { eventYears } = get('content');

	let showSpacecraft = false;
	const router = get('route');

	if (router?._history?.location?.pathname) {
		const { pathname } = router._history.location;
		showSpacecraft = pathname.indexOf('spacecraft') >= 0;
	}

	if (showSpacecraft) {
		return null;
	}

	return (
		<div
			className={'event-dropdowns-container' + (showOnGlobe ? ' event-dropdowns-offset' : '')}
		>
			<Filter type='dropdown' style={{ padding: 10 }} allItems={eventYears} selectedIndex={yearIndex} updateItem={updateYear} />
			<Filter type='dropdown' style={{ padding: 10 }} allItems={EVENT_CATEGORIES} selectedIndex={categoryIndex} updateItem={updateCategory} />
		</div>
	);
};


export default EventDropdowns;
